import filterLoans from '../libs/filterLoans';

export default {
  amount: window.slider_amounts || [
    1000,
    2000,
    3000,
    4000,
    5000,
    6000,
    7000,
    8000,
    9000,
    10000,
    11000,
    12000,
    13000,
    14000,
    15000,
    16000,
    17000,
    18000,
    19000,
    20000,
    21000,
    22000,
    23000,
    24000,
    25000,
    26000,
    27000,
    28000,
    29000,
    30000,
    31000,
    32000,
    33000,
    34000,
    35000,
    36000,
    37000,
    38000,
    39000,
    40000,
    41000,
    42000,
    43000,
    44000,
    45000,
    46000,
    47000,
    48000,
    49000,
    50000,
    51000,
    52000,
    53000,
    54000,
    55000,
    56000,
    57000,
    58000,
    59000,
    60000,
    61000,
    62000,
    63000,
    64000,
    65000,
    66000,
    67000,
    68000,
    69000,
    70000,
    71000,
    72000,
    73000,
    74000,
    75000,
    76000,
    77000,
    78000,
    79000,
    80000,
    81000,
    82000,
    83000,
    84000,
    85000,
    86000,
    87000,
    88000,
    89000,
    90000,
    91000,
    92000,
    93000,
    94000,
    95000,
    96000,
    97000,
    98000,
    99000,
    100000,
    105000,
    110000,
    115000,
    120000,
    125000,
    130000,
    135000,
    140000,
    145000,
    150000,
  ],
  repayment: window.slider_periods || [
    1,
    2,
    3,
    4,
    5,
    6,
    8,
    10,
    12,
    24,
    36,
    48,
    60,
    72,
  ],
  default: {
    amount: window.default_slider_amount || window.loan_data.quick.amount || 10000,
    repayment: window.default_slider_period || window.loan_data.quick.repayment || 6,
  },
  isVersion2() {
    return document.querySelector('.loan-plugin-list-section-2')
  },
  onChange(slider) {

    let url = '#loan-list'
    let query_string = `?amount=${slider.calculator.amount}&repayment=${slider.calculator.repayment}#loan-list`
    // eslint-disable-next-line
    if (typeof redirects_url !== 'undefined' && redirects_url) {
      let isset = false
      // eslint-disable-next-line
      redirects_url.forEach((v) => {
        if (slider.calculator.amount < parseInt(v.amount) && !isset) {
          url = v.url + query_string;
          isset = true
        }
      })
    } else if (slider.calculator.amount < 50000) {
      url = `/snabblan/${query_string}`;
    }

    slider.link.setAttribute('href', url)

    console.log('isVersion2()', this.isVersion2())

    // V2
    // if (this.isVersion2()) {
      filterLoans(window.loan_lists[0], slider)
    // } else {
    //   //V1
    //   if (window.loanLists[0]) {
    //     window.loanLists[0].filter(x => {
    //       return x.max_amount >= slider.calculator.amount && x.min_amount <= slider.calculator.amount && x.max_loanperiod >= slider.calculator.repayment && x.min_loanperiod <= slider.calculator.repayment;
    //     })
    //   }
    //   slider.link.innerText = `Jämför ${window.loanLists[0].count()} långivare`
    // }

  },
}



// WEBPACK FOOTER //
// ./scripts/Data/quick-loan.js